/**
 * Sales order document viewer — a thin wrapper over the shared
 * DocumentPrintPage with the sales-order (customer-facing) configuration,
 * which lives in docPrintConfigs so the public `/d/:token` paper renders from
 * the very same object.
 */
import { SALES_ORDER_DOC_CONFIG } from './docPrintConfigs.js';
import { DocumentPrintPage } from './DocumentPrintPage.js';

export function SalesOrderPrintPage(): JSX.Element {
  return <DocumentPrintPage config={SALES_ORDER_DOC_CONFIG} />;
}
